import { Card, CardContent, Typography } from "@mui/material";
import { FilterList, FilterListItem, FilterLiveSearch } from "react-admin";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { endOfYesterday, startOfMonth, startOfWeek, subMonths, subWeeks } from "date-fns";

export const RecordOwnershipAside = ({ source }: { source: string }) => (
  <Card
    sx={{
      display: {
        xs: "none",
        md: "block",
      },
      order: -1,
      flex: "0 0 15em",
      mr: 2,
      alignSelf: "flex-start",
    }}
  >
    <CardContent sx={{ pt: 1 }}>
      <Typography variant="h3">Filters</Typography>
      <FilterLiveSearch source={source} />
      {/* TODO: The filter list is also used in the client aside and should be made
        into a reusable component */}
      <FilterList label="Last Visited" icon={<AccessTimeIcon />}>
        <FilterListItem
          label="Today"
          value={{
            last_seen_gte: endOfYesterday().toISOString(),
            last_seen_lte: undefined,
          }}
        />
        <FilterListItem
          label="This Week"
          value={{
            last_seen_gte: startOfWeek(new Date()).toISOString(),
            last_seen_lte: undefined,
          }}
        />
        <FilterListItem
          label="Last Week"
          value={{
            last_seen_gte: subWeeks(startOfWeek(new Date()), 1).toISOString(),
            last_seen_lte: startOfWeek(new Date()).toISOString(),
          }}
        />
        <FilterListItem
          label="This Month"
          value={{
            last_seen_gte: startOfMonth(new Date()).toISOString(),
            last_seen_lte: undefined,
          }}
        />
        <FilterListItem
          label="Last Month"
          value={{
            last_seen_gte: subMonths(startOfMonth(new Date()), 1).toISOString(),
            last_seen_lte: startOfMonth(new Date()).toISOString(),
          }}
        />
        <FilterListItem
          label="Earlier"
          value={{
            last_seen_gte: undefined,
            last_seen_lte: subMonths(startOfMonth(new Date()), 1).toISOString(),
          }}
        />
      </FilterList>
    </CardContent>
  </Card>
);
